import * as React from "react";

const SvgIcnTransferBold = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path
                d="M4.531 18.719a.44.44 0 01-.312-.117.522.522 0 01-.157-.305c0-.042-.018-.3-.054-.774-.037-.474-.013-1.054.07-1.742.083-.687.258-1.43.524-2.226a6.74 6.74 0 011.289-2.242 6.89 6.89 0 011.234-1.133 7.514 7.514 0 011.523-.836 9.899 9.899 0 011.797-.54c.64-.13 1.326-.205 2.055-.226l.016-2.797c0-.104.026-.195.078-.273a.52.52 0 01.203-.18.537.537 0 01.281-.047c.094.01.177.047.25.11l6.485 5.312a.513.513 0 01.187.39.498.498 0 01-.188.391l-6.484 5.375a.453.453 0 01-.25.11.537.537 0 01-.281-.047.501.501 0 01-.203-.188.493.493 0 01-.078-.265l-.016-2.875c-1.75 0-3.125.234-4.125.703s-1.75.99-2.25 1.562c-.5.573-.815 1.107-.945 1.602-.13.495-.196.763-.196.805a.538.538 0 01-.132.32.387.387 0 01-.305.133H4.53z"
                fill="currentColor"
            />
        </g>
    </svg>
);

export default SvgIcnTransferBold;
